import React, { useState, useEffect } from 'react';
import { Col, Form, FormGroup, Label, Input, Button, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { loginApi , userApi} from '../../services/consts';
import { getCurrentUser,tokenHeader, getUserToken } from '../../services/user-service';
import { setUserData } from '../../services/dataService';
import crmlogo from '../../assets/images/marketcrm.png';
import apifdfLogo from '../../assets/images/APIFDF.png';
import mcrmlogo from '../../assets/images/market-crm.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = (props) => {
   const apiEndPoint = userApi;
   const [passwordShow, setPasswordShow] = useState(false);
   const passwordVisiblity = () => {
      setPasswordShow(passwordShow ? false : true);
   };

   let email, password;
   useEffect(() => {
      getCurrentUser().then((user) => {
         if (user != null) {
            props.history.push('/dashboard');
         }
      })
   })
   var doLogin = (e) => {
      let methodType = 'post';
      var loginData = {
         email: email.value,
         password: password.value
      };
      fetch(loginApi, {
         method: methodType,
         body: JSON.stringify(loginData),
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
         }
      }).then(res => res.json())
         .then((result) => {
            if (result.result == "success") {
               localStorage.setItem('userToken', result.token);
               getCurrentUser().then((user) => {
                  if (user != null) {
                         let methodType = 'put';
                         var loginData = {
                             lastLogin: new Date()
                             };
                         if (user.id != 0) { //to update
                             methodType = 'put';
                             loginData.id = user.id;
                         }
                         fetch(apiEndPoint, {
                            method: methodType,
                            body: JSON.stringify(loginData),
                            headers: {
                               'Accept': 'application/json',
                               'Content-Type': 'application/json',
                               [tokenHeader]: getUserToken()
                            },
                           
                         }).then(res => res.json())
                            .then((result) => {
                                if(result){
                                 setUserData(JSON.stringify(user.name));
                                 localStorage.setItem('user', JSON.stringify(user));
                                 props.history.push('/dashboard');
                                }
                            })
                            .catch(() => {
                             //   return toast.error("Server is not working.");
                            })
                  }
               });
            } else {
               // alert(result.msg);
               toast.error(result.msg);
            }
         })
         .catch(() => {
            return toast.error("Server is not working.");
         })
   };
   return (
      <div style={{ marginTop: '5%', marginLeft: '10%', marginRight: '10%', marginBottom: '5%' }} >
         <ToastContainer
            position="top-center"
            autoClose={2000}
            hideProgressBar={true}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
         />
         {/* <h3>Login</h3> */}
         {/* <img src={crmlogo} style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: '18rem' }}></img><br /> */}
         {/* <br /> */}
         <Form>
            <FormGroup row>
               <Col sm={4}></Col>
               <Col sm={4}>
                  <img src={apifdfLogo} style={{ width: '80%' }}></img>
               </Col>
               <Col sm={4}></Col>
            </FormGroup>
            <FormGroup row>
               <Col sm={4}></Col>
               <Col sm={4}>
                  <InputGroup style={{ width: '80%' }}>
                     <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="fas fa-user"></i></InputGroupText>
                     </InputGroupAddon>
                     <Input innerRef={(b) => { email = b }} type="text" name="email" placeholder="example@gmail.com" />
                  </InputGroup>

               </Col>
               <Col sm={4}></Col>
            </FormGroup>
            <FormGroup row>
               <Col sm={4}></Col>
               <Col sm={4}>
                  <InputGroup style={{ width: '80%' }}>
                     <InputGroupAddon addonType="prepend">
                        <InputGroupText><i className="fas fa-key"></i></InputGroupText>
                     </InputGroupAddon>
                     <Input innerRef={(b) => { password = b }} type={passwordShow ? "text" : "password"} name="password" placeholder="" />
                     <InputGroupAddon addonType="prepend">
                        <InputGroupText><i onClick={passwordVisiblity} className="fa fa-eye"></i></InputGroupText>
                     </InputGroupAddon>
                  </InputGroup>
               </Col>
               <Col sm={4}></Col>
            </FormGroup>
            <FormGroup row>
               <Col sm={4}></Col>
               <Col sm={4}>
                  <Button className="btn btn-primary btn-block" style={{ width: '80%' }} onClick={doLogin} color="primary">
                     Login
                  </Button>
               </Col>
               <Col sm={4}></Col>
            </FormGroup>
         </Form>
      </div>
   );
}
export default Login;
